import { Injectable } from '@angular/core';
import { LogicFnContext } from '@workflow/service/logic/logic.service';

/**
 * This service will be used for custom page validations
 * Methods on this service get registered as 'logic functions' on LogicService
 */
@Injectable({
  providedIn: 'root'
})
export class PageValidationFunctionsService {
  constructor() {}

  /**
   * this function intentionally left blank
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public customPageValidation = (context: LogicFnContext): boolean => {
    return false;
  };
}
